import React, {Component} from "react";
import MenuRender from "./menuRender";

class Menu extends Component {
    render() {
        let {
            isMenuReceiver,
            lastElem,
            handlerOnMessage,
            handleChangeHeightWithMenu,
        } = this.props;

        return (
            <div id="smMenu" className="sm-menu">
                <div>
                    {isMenuReceiver && <MenuRender
                        lastElem={lastElem}
                        handlerOnMessage={handlerOnMessage}
                        handleChangeHeightWithMenu={handleChangeHeightWithMenu}
                    />}
                </div>
            </div>
        )
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/index.js